<template>
  <div v-bind="$attrs">
    <img
      v-if="getIcon"
      class="rounded-full object-cover flex-shrink-0"
      :class="{'grayscale' : disabled}"
      :style="{
        height: height + 'px',
        minWidth: width + 'px',
        width: width + 'px',
      }"
      :src="getIcon"
      alt="imagen del país"
    />
    <div v-else class="w-5 h-5 rounded-full bg-grey-25"></div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

// HELPERS
import { getAsset } from '@/helpers/assets';

export default defineComponent({
  name: 'GSelectAvatar',
  props: {
    countryCode: {
      type: String,
      default: '',
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const getIcon = computed(() => {
      const img =
        props.countryCode &&
        getAsset(
          `flags/gc_country_flag_${props.countryCode.toLowerCase()}.png`
        );
      return (props.countryCode && img) || '';
    });
    return {
      getIcon,
    };
  },
});
</script>
